export default "__VITE_PUBLIC_ASSET__afd096ed__"